import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/Home";
import ContactPage from "./pages/Contact";
import ServicesPage from "./pages/Services";
import AboutUs from "./pages/About";
import GalleryPage from "./pages/Gallery";
import ServiceDetail from "./pages/ServiceDetail";
import "./index.css";
import ScrollToTop from "./components/ScrollToTop";
import BlogsPage from "./pages/Blogs";
import BookingPage from "./pages/BookingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfServices";
import BlogPost from "./pages/blog/blog";

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/services/:serviceSlug" element={<ServiceDetail />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
         <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
